import { Link, useLocation } from 'react-router-dom'
import { ChevronRight, ExternalLink } from 'lucide-react'

import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@/components/ui/collapsible'
import {
  SidebarGroup,
  SidebarMenu,
  SidebarMenuAction,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
} from '@/components/ui/sidebar'
import { ROUTES } from '@/lib/routes'

export function NavMain() {
  const location = useLocation()
  const pathname = location.pathname
  const routes = Object.values(ROUTES)

  return (
    <SidebarGroup>
      <SidebarMenu>
        {routes.map(item => {
          const isActive = pathname.startsWith(item.path)
          const isExternal = item.path.startsWith('http')

          if (item.items?.length) {
            return (
              <SidebarMenuItem key={item.title}>
                <Collapsible defaultOpen={isActive} className="group">
                  <div className="flex items-center">
                    <CollapsibleTrigger asChild>
                      <SidebarMenuButton isActive={isActive} className="ml-1">
                        <item.icon />
                        <span>{item.title}</span>
                      </SidebarMenuButton>
                    </CollapsibleTrigger>
                    <SidebarMenuAction className="transition-transform duration-200 group-data-[state=open]:rotate-90">
                      <ChevronRight className="h-4 w-4" />
                      <span className="sr-only">Toggle</span>
                    </SidebarMenuAction>
                  </div>
                  <CollapsibleContent>
                    <SidebarMenuSub>
                      {item.items.map(subItem => {
                        const isSubExternal = subItem.path.startsWith('http')

                        return (
                          <SidebarMenuSubItem key={subItem.title}>
                            <SidebarMenuSubButton
                              asChild
                              isActive={pathname === subItem.path}
                            >
                              {isSubExternal ? (
                                <a
                                  href={subItem.path}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <span>{subItem.title}</span>
                                  <ExternalLink className="ml-1 h-3 w-3" />
                                </a>
                              ) : (
                                <Link to={subItem.path!}>
                                  <span>{subItem.title}</span>
                                </Link>
                              )}
                            </SidebarMenuSubButton>
                          </SidebarMenuSubItem>
                        )
                      })}
                    </SidebarMenuSub>
                  </CollapsibleContent>
                </Collapsible>
              </SidebarMenuItem>
            )
          }

          // For items without subitems, they can be direct links

          return (
            <SidebarMenuItem key={item.title}>
              <SidebarMenuButton asChild isActive={isActive}>
                {isExternal ? (
                  <a href={item.path} target="_blank" rel="noopener noreferrer">
                    <item.icon className="ml-1" />
                    <span>{item.title}</span>
                  </a>
                ) : (
                  <Link to={item.path!}>
                    <item.icon className="ml-1" />
                    <span>{item.title}</span>
                  </Link>
                )}
              </SidebarMenuButton>
            </SidebarMenuItem>
          )
        })}
      </SidebarMenu>
    </SidebarGroup>
  )
}
